"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = lazyImage;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
  (0, _forEach["default"])(entries).call(entries, function (entry) {
    if (entry.isIntersecting) {
      var _lazyImage = entry.target;
      _lazyImage.src = _lazyImage.dataset.src;
      _lazyImage.srcset = _lazyImage.dataset.srcset;

      _lazyImage.classList.add('lazy-loading');

      if (!_lazyImage.complete) {
        _lazyImage.addEventListener('load', function () {
          _lazyImage.classList.remove('lazy-loading');
        });
      } else {
        _lazyImage.classList.remove('lazy-loading');
      }

      _lazyImage.removeAttribute('data-src');

      _lazyImage.removeAttribute('data-srcset');

      lazyImageObserver.unobserve(_lazyImage);
    }
  });
});

function lazyImage() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var lazyImages = el.querySelectorAll('img[data-src]');
  (0, _forEach["default"])(lazyImages).call(lazyImages, function (lazyImage) {
    lazyImage.classList.add('lazy-image');
    lazyImageObserver.observe(lazyImage);
  });
}